import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AdministrationComponent } from './administration/administration.component';
import { AssignmentPvbComponent } from './assignment-pvb/assignment-pvb.component';
import { MatInputModule, MatFormFieldModule, MatButtonModule, MatSlideToggleModule, MatIconModule, 
    MatDatepickerModule, MatNativeDateModule, MatRadioModule } from '@angular/material';
import { BreadcrumbModule } from '../../breadcrumb/breadcrumb.module';
import { InternshipAssignmentComponent } from './internship-assignment/internship-assignment.component';
import { FileUploadModule } from '../../file-upload/file-upload.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SigningComponent } from './signing/signing.component';
import { CompanySigningComponent } from './company-signing/company-signing.component';
import { StudentSigningComponent } from './student-signing/student-signing.component';
import { ExaminationCommitteeSigningComponent } from './examination-committee-signing/examination-committee-signing.component';
import { SemsoPdfViewerModule } from '../../semso-pdf-viewer/semso-pdf-viewer.module';
import { SignaturePadModule } from 'angular2-signaturepad';
import { StateService } from './state.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        BreadcrumbModule,
        MatButtonModule,
        MatSlideToggleModule,
        FileUploadModule,
        SemsoPdfViewerModule,
        SignaturePadModule,
        MatDatepickerModule,
        MatRadioModule,
        BreadcrumbModule
    ],
    declarations: [
        AdministrationComponent,
        AssignmentPvbComponent,
        InternshipAssignmentComponent,
        SigningComponent,
        CompanySigningComponent,
        StudentSigningComponent,
        ExaminationCommitteeSigningComponent
    ],
    exports: [
        AdministrationComponent,
        AssignmentPvbComponent
    ],
    providers: [StateService]
})
export class AssignmentPvbModule { }



// WEBPACK FOOTER //
// ./src/app/exam-preparation/assignment-pvb/assignment-pvb.module.ts